var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.order)
    ? _c(
        "div",
        { staticClass: "prod_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "cid1",
              f_title: _vm.__t("ORDER.UID"),
              f_val: _vm.order.order.uniq_id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid2",
              f_title: _vm.__t("ORDER.ID"),
              f_val: _vm.order.order.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid3",
              f_title: _vm.__t("ORDER.CODE"),
              f_val: _vm.order.order.order_code.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid4",
              f_title: _vm.__t("LOAD_FROM"),
              f_icon: "fa-sync",
              f_val: _vm.providers.agr,
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid5",
              f_title: _vm.__t("ACCEPT_FROM"),
              f_icon: "fa-sync",
              f_val: _vm.providers.pos,
            },
          }),
          _vm._v(" "),
          !_vm.order.is_delivery
            ? _c(
                "div",
                [
                  _c("info_field", {
                    attrs: {
                      f_uniq: "cid6",
                      f_title: _vm.__t("ORDER.TOTAL"),
                      f_icon: "fa-money-bill",
                      f_val: _vm.order_price.total.toString(),
                    },
                  }),
                  _vm._v(" "),
                  _c("info_field", {
                    attrs: {
                      f_uniq: "cid6",
                      f_title: _vm.__t("ORDER.SUBTOTAL"),
                      f_icon: "fa-money-bill",
                      f_val: _vm.order_price.subtotal.toString(),
                    },
                  }),
                  _vm._v(" "),
                  parseFloat(_vm.order_price.discount) > 0
                    ? _c("info_field", {
                        attrs: {
                          f_uniq: "cid6",
                          f_title: _vm.__t("ORDER.DUSCOUNT"),
                          f_icon: "fa-money-bill",
                          f_val: _vm.order_price.discount.toString(),
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid7",
              f_title: _vm.__t("O_STATUS"),
              f_icon: "fa-sync",
              f_val: _vm.order.status,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }